/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import safeInclude from "./safeInclude";
import { mimeTypeToExtension } from "./getFileMIME";
import warning from "./warning";

const getBase64Details = (str: string) => {
  try {
    const details = {
      extension: "N/A",
      src: str,
      initial: str,
    }
    if (!str) return details
    function isBase64(str: string) {
      if (safeInclude(str, "base64")) return true;
      const regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
      return regex.test(str);
    }

    if (str && isBase64(str) && str.length > 100) {
      // data:image/jpeg;base64,....
      const mimeType = str
        // [data:image/jpeg, ...][0]
        .split(";")[0]
        // [data, image/jpeg][1]
        .split(":")[1];
      // "image/jpeg"
      const extension = mimeTypeToExtension(mimeType) || "";
      if (extension) {
        details.extension = extension;
      } else {
        // to handle base64 strings without the prefix and mimeType
        const src = `data:image/png;base64,` + str;
        details.src = src;
        details.extension = "png";

      }
    }
    return details;
  }
  catch (err) {
    warning(err)
    return {
      extension: "N/A",
      src: "",
      initial: "",
    }
  }
}


export default getBase64Details;